<template>
  <div class="find">
    <div class="background-screen">
    <video class="background-video" loop muted playsinline data-autoplay data-keepplaying>
      <source data-src="https://player.vimeo.com/external/336219707.hd.mp4?s=1d891a1d79ab6ea00e71d9e7ad7564bfd70fbd72&profile_id=175" type="video/mp4" >
    </video>
    </div>

    <img class="find-bottom-left-fruit" data-src="./assets/find/find-bottom-left-fruit.png">
    <img class="find-upper-corner-fruit" data-src="./assets/find/find-upper-corner-fruit.png">
    <div class="breadcrumb">05&nbsp;&mdash;&nbsp;Where to buy</div>

    <div class="find-content">
      <img class="find-hero-image" data-src="./assets/find/find-hero.png">
      <div class="find-text">
        <h2>Venture Off<br> Your Grocery List</h2>
        <p>Adventure awaits. Find stores near you that carry Zespri SunGold Kiwifruit, then wander there to get a taste of this unique fruit.</p>
      </div>
      <div class="find-buttons">
        <a href="/en-US/wheretobuy" target="_blank" class="find-button">
          <i class="button-icon find-store-icon"><find-store-icon /></i>
          Find a Store
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import FindStoreIcon from '../assets/icons/find-store.svg?inline'
import CouponIcon from '../assets/icons/coupon.svg?inline'


export default {
  name: 'find',
  components: {
    'find-store-icon': FindStoreIcon,
    'coupon-icon': CouponIcon
  },
  computed: {
    couponUrl(){
      return store.state.couponUrl
    },
  },
}
</script>

<style scoped lang="scss">
/** find **/
@import '../theme';

.find {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  @include media-breakpoint-up(lg) {
    height: 100vh;
  }

  .background-video {
    background-color: zespri-brand-color(dark-green);
    position: absolute;
    left: 50%;
    top: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translateX(-50%);
  }

  .background-screen{
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    &::after{
      content: '';
      background-color: rgba(zespri-brand-color(dark-green), 0.9);
      display: block;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
    }
  }

  .find-bottom-left-fruit {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30%;
  }

  .find-upper-corner-fruit {
    position: absolute;
    top: 0;
    right: 0;
    width: 33%;

    @include media-breakpoint-up(md) {
      width: 20%;
    }
  }

  .breadcrumb {
    position: absolute;
    @include zespri-tiny-title;
    color: zespri-brand-color(white);
    left: 32px;
    top: 40px;

    @include media-breakpoint-up(md) {
      left: 8%;
    }
  }

  .find-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    z-index: zespri-layer(normal);

    position: relative;

    @include media-breakpoint-up(md) {
      padding: 0;
      width: 45%;
    }

    .find-hero-image {
      width: 100%;
      max-height: 330px;
    }

    .find-text {
      @include media-breakpoint-up(md) {
        width: 90%;
        margin-top: -40px;
      }

      h2, p {
        color: zespri-brand-color(white);
      }
    }

    .find-buttons {
      display: flex;
      flex-direction: column;
      align-items: center;

      @include media-breakpoint-up(xl) {
        flex-direction: row;
      }

      .find-button {
        @include cta-button(zespri-brand-color(dark-green), zespri-brand-color(white), zespri-brand-color(green));
        margin: 15px 0;

        @include media-breakpoint-up(xl) {
          margin: 0 20px;
        }

        .button-icon {
          display: inline-block;
          margin-right: 8px;
          fill: zespri-brand-color(red);

          &.find-store-icon {
            width: 11px;
            height: 18px;
          }

          &.coupon-icon {
            width: 22px;
            height: 18px;
          }
        }
      }
    }
  }
}

</style>
